// auth0-config.js
export const auth0Config = {
    domain: 'dev-cwup0joa8z4u1i1r.us.auth0.com',
    clientId: 'VvjXciihh4m98L4KpjhKf4keUVx0h2eX',
    redirectUri: window.location.origin,
  };
  